import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { useSubscription } from "react-relay"
import { graphql, GraphQLSubscriptionConfig } from "relay-runtime"
import { useWebNotificationsSubscription as WebNotificationsSubscription } from "@/hooks/__generated__/useWebNotificationsSubscription.graphql"
import { showNotification } from "@/lib/push-notification"

const webNotificationsSubscription = graphql`
  subscription useWebNotificationsSubscription {
    webNotifications {
      notificationId
      kind
      actionTriggeredBy
      patient {
        id
        country
        firstName
        lastName
      }
      appointment {
        id
        chatDetails {
          chatThreadId
        }
      }
    }
  }
`

const useWebNotificationsSubscription = () => {
  const { t } = useTranslation()
  const subscriptionConfig: GraphQLSubscriptionConfig<WebNotificationsSubscription> = useMemo(() => {
    return {
      subscription: webNotificationsSubscription,
      variables: {},
      onNext: (res) => {
        if (!res) return
        showNotification(res, t)
      },
      cacheConfig: { metadata: { sensitive: true } },
    }
  }, [t])

  return useSubscription<WebNotificationsSubscription>(subscriptionConfig)
}

export { useWebNotificationsSubscription }
